import { computed, defineComponent, inject, ref } from "vue";
import { useI18n } from "vue-i18n";
import html_iway from "./template.iway.html?raw";
import { orderServiceKey } from "../../../infrastructure/gfo_api/order_service";
import { ApiValidationError } from "../../../infrastructure/gfo_api/api_validation_error";
import ErrorMessage from "../../Shared/ErrorMessage";
const app_theme = import.meta.env.VITE_APP_THEME;
let html = "";
if ("iway" == app_theme) {
  html = html_iway;
} else if ("lic" == app_theme) {
  html = html_iway;
} else if ("sak" == app_theme) {
  html = html_iway;
}

const PRODUCT_ID_MOBILE_PORTING = 31;

export default defineComponent({
  template: html,
  components: {ErrorMessage},
  setup() {
    // Injections
    const { t } = useI18n();
    const orderService = inject(orderServiceKey);

    // vars und computed
    const error = ref<string>("");
    const currentItem = computed(() => {
      return orderService?.currentItems?.value?.find((it) => it.product_id == PRODUCT_ID_MOBILE_PORTING) ?? null;
    });

    const availableVaraints = computed(() => {
      return orderService?.availableVariants?.value?.filter(
        (v) => v.product_id == PRODUCT_ID_MOBILE_PORTING && v.qty_price_for == 0,
      ) ?? null;
    });

    // methods
    const onSelectionChange = async (newId:number) => {

      error.value = "";
      try {
        await orderService?.addToCart(newId, "", 1);
      } catch (err){
        if ( err instanceof ApiValidationError){
          error.value = err.title;
        } else {
          error.value = `${err}`;
        }
      }
    };

    return {
      t,
      availableVaraints,
      currentItem,
      error,
      onSelectionChange,
    };
  },
} as any);
